import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import "./TONearbyLanding.css";

const metaDescription =
  "TONearby helps people in Toronto find nearby parks, community centres, drop-in activities, and facility details.";

function TONearbyLanding() {
  useEffect(() => {
    const previousTitle = document.title;
    let description = document.querySelector('meta[name="description"]');
    const previousDescription = description && description.getAttribute("content");
    const createdDescription = !description;

    if (!description) {
      description = document.createElement("meta");
      description.setAttribute("name", "description");
      document.head.appendChild(description);
    }

    document.title = "TONearby";
    description.setAttribute("content", metaDescription);

    return () => {
      document.title = previousTitle;

      if (createdDescription) {
        description.remove();
      } else if (previousDescription) {
        description.setAttribute("content", previousDescription);
      }
    };
  }, []);

  return (
    <main className="tonearby-landing">
      <Container className="tonearby-landing__container">
        <a className="tonearby-landing__back-link" href="/">
          Back to portfolio
        </a>
        <section className="tonearby-landing__content">
          <p className="tonearby-landing__eyebrow">TONearby</p>
          <h1>TONearby</h1>
          <p>
            TONearby helps people in Toronto find nearby parks, community
            centres, drop-in activities, and facility details quickly.
          </p>
          <p>
            Use your current location or choose a custom area, then search
            within a radius. Filter by activity, date, time, age group, free
            community centres, park amenities, and alcohol-permitted parks. View
            results on a map or list, open facility details, and jump to
            directions or official City of Toronto pages.
          </p>
          <p>
            TONearby is designed for quick local discovery using public City of
            Toronto recreation and facility information.
          </p>
          <div className="tonearby-landing__links" aria-label="TONearby links">
            <a href="/tonearby/support">Support</a>
            <a href="/tonearby/privacy">Privacy Policy</a>
          </div>
        </section>
      </Container>
    </main>
  );
}

export default TONearbyLanding;
